/**
 * The Leaflet version in use.
 * @example
 * ```js
 * import {version} from 'leaflet';
 *
 * console.log(version); // "2.0.0", or whatever version is in use
 * ```
 */
export const version = '2.0.0-beta.1';

// control
export {AttributionControl} from './control/AttributionControl.js';
export {Control} from './control/Control.js';
export {LayersControl} from './control/LayersControl.js';
export {ScaleControl} from './control/ScaleControl.js';
export {ZoomControl} from './control/ZoomControl.js';

// core
export {Class} from './core/Class.js';
export {Evented} from './core/Events.js';
export {Handler} from './core/Handler.js';
export * as Util from './core/Util.js';

// dom
export * as DomEvent from './dom/DomEvent.js';
export * as DomUtil from './dom/DomUtil.js';
export {Draggable} from './dom/Draggable.js';

// geometry
export {Point} from './geometry/Point.js';
export {Bounds} from './geometry/Bounds.js';
export {Transformation} from './geometry/Transformation.js';
export * as LineUtil from './geometry/LineUtil.js';
export * as PolyUtil from './geometry/PolyUtil.js';

// geo
export {LatLng} from './geo/LatLng.js';
export {LatLngBounds} from './geo/LatLngBounds.js';
export {LonLatProjection} from './geo/projection/LonLatProjection.js';
export {MercatorProjection} from './geo/projection/MercatorProjection.js';
export {SphericalMercatorProjection} from './geo/projection/SphericalMercatorProjection.js';
export {CRS} from './geo/crs/CRS.js';
export {EarthCRS} from './geo/crs/EarthCRS.js';
export {EPSG3395} from './geo/crs/EPSG3395.js';
export {EPSG3857, EPSG900913} from './geo/crs/EPSG3857.js';
export {EPSG4326} from './geo/crs/EPSG4326.js';
export {SimpleCRS} from './geo/crs/SimpleCRS.js';

// layer
export {Layer} from './layer/Layer.js';
export {LayerGroup} from './layer/LayerGroup.js';
export {FeatureGroup} from './layer/FeatureGroup.js';
export {GeoJSON} from './layer/GeoJSON.js';
export {BlanketOverlay} from './layer/BlanketOverlay.js';
export {ImageOverlay} from './layer/ImageOverlay.js';
export {VideoOverlay} from './layer/VideoOverlay.js';
export {SVGOverlay} from './layer/SVGOverlay.js';
export {DivOverlay} from './layer/DivOverlay.js';
export {Popup} from './layer/Popup.js';
export {Tooltip} from './layer/Tooltip.js';

// layer/marker
export {Icon} from './layer/marker/Icon.js';
export {DefaultIcon} from './layer/marker/DefaultIcon.js';
export {DivIcon} from './layer/marker/DivIcon.js';
export {Marker} from './layer/marker/Marker.js';

// layer/tile
export {GridLayer} from './layer/tile/GridLayer.js';
export {TileLayer} from './layer/tile/TileLayer.js';
export {WMSTileLayer} from './layer/tile/WMSTileLayer.js';

// layer/vector
export {Renderer} from './layer/vector/Renderer.js';
export {Canvas} from './layer/vector/Canvas.js';
export {SVG} from './layer/vector/SVG.js';
export {Path} from './layer/vector/Path.js';
export {CircleMarker} from './layer/vector/CircleMarker.js';
export {Circle} from './layer/vector/Circle.js';
export {Polyline} from './layer/vector/Polyline.js';
export {Polygon} from './layer/vector/Polygon.js';
export {Rectangle} from './layer/vector/Rectangle.js';

// map
export {Map, LeafletMap} from './map/Map.js';
export {BoxZoomHandler} from './map/handler/BoxZoomHandler.js';
export {DoubleClickZoomHandler} from './map/handler/DoubleClickZoomHandler.js';
export {DragHandler} from './map/handler/DragHandler.js';
export {KeyboardHandler} from './map/handler/KeyboardHandler.js';
export {ScrollWheelZoomHandler} from './map/handler/ScrollWheelZoomHandler.js';
export {TapHoldHandler} from './map/handler/TapHoldHandler.js';
export {PinchZoomHandler} from './map/handler/PinchZoomHandler.js';
